import React from "react";
import ActionsPopup from "../../ProfilesDetail/Table/ActionsPopup";
import schema from "../../ProfilesDetail/Table/ActionsPopup/agent_attorney_actions";

const foreign_worker_group_modal_columns = (
  linkedProfiles,
  setLinkedProfiles
) => [
  {
    Header: ({ data }) => {
      let allIds = data.map((item) => item.id);
      let allChecked = allIds?.length === linkedProfiles?.length;
      return (
        <>
          <input
            id={`allListed`}
            onClick={(e) => {
              if (e.currentTarget.checked) {
                setLinkedProfiles(allIds);
              } else {
                setLinkedProfiles([]);
              }
            }}
            className="usa-checkbox__input"
            type="checkbox"
            checked={allChecked}
          />
          <label
            className="usa-checkbox__label"
            style={{ margin: 0 }}
            htmlFor={`allListed`}
            onChange={(e) => e}
            checked={allChecked}
          />
        </>
      );
    },
    disableSortBy: true,
    id: "id",
    accessor: "id",
    fixedWidth: 65,
    Cell: ({ value, row: { index }, column: { id } }) => {
      const checked = linkedProfiles.includes(value);
      return (
        <>
          <input
            id={value}
            className="usa-checkbox__input"
            type="checkbox"
            checked={checked}
            onClick={(e) => {
              if (e.currentTarget.checked) {
                setLinkedProfiles((prev) => [...prev, value]);
              } else {
                setLinkedProfiles(linkedProfiles.filter((id) => id !== value));
              }
            }}
          />
          <label
            className="usa-checkbox__label"
            style={{
              padding: 0,
              margin: "2px 0",
              textIndent: 0,
            }}
            htmlFor={value}
            checked={checked}
          />
        </>
      );
    },
  },
  {
    Header: "Profile Name",
    id: "new_profile_fw_profile_name",
    accessor: (data) => data.new_profile_fw_profile_name,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
    minWidth: 200,
    maxWidth: 250,
  },
  {
    Header: "Foreign Worker Name",
    id: "new_profile_fw_last",
    accessor: (data) => data.new_profile_fw_last,
    Cell: ({ row: { original } }) => (
      <span>
        {`${original.new_profile_fw_first} ${original.new_profile_fw_last}`}
      </span>
    ),
  },
  {
    Header: "Date of Birth",
    id: "new_profile_fw_dob",
    accessor: (data) => data.new_profile_fw_dob,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
    maxWidth: 150,
  },
  {
    Header: "Alien Registration Number",
    id: "new_profile_fw_alien_reg_number",
    accessor: (data) => data.new_profile_fw_alien_reg_number,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
    maxWidth: 250,
  },
  {
    Header: "Actions",
    id: "actions",
    accessor: "actions",
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema("foreign-worker", true)}
        id={original.id}
        removeProfile={{
          linkedProfiles,
          setLinkedProfiles,
        }}
      />
    ),
  },
];

export default foreign_worker_group_modal_columns;
